import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    navVisible: false,
    containerSize: {
      width: 0,
      marginLeft: 0,
    },
    sections: [
      {
        id: 'home',
        name: 'Home',
        category: 'Main',
        visible: false,
      },
      {
        id: 'projects',
        name: 'Projects',
        category: 'Main',
        visible: true,
        isAffixed: true,
        component: 'Projects',
        anim: {
          name: 'projectsAnim',
          delay: 0,
        },
        left: {
          classes: ['bg-color-white']
        },
        right: {
          classes: ['bg-color-white']
        },
      },
      {
        id: 'about',
        name: 'About',
        category: 'Main',
        visible: true,
        isAffixed: true,
        component: 'About',
        anim: {
          name: 'aboutAnim',
          delay: 500,
        },
        left: {
          classes: ['bg-color-light-gray']
        },
        right: {
          classes: ['bg-color-red']
        },
      },
      {
        id: 'contact',
        name: 'Contact',
        category: 'Main',
        visible: true,
        isAffixed: false,
        component: 'Contact',
        anim: {
          name: 'contactAnim',
          delay: 1000,
        },
      },
      {
        id: 'proj1sect1',
        name: 'IKEA SSFA dashboard',
        category: 'Project1',
        visible: true,
        isAffixed: true,
        component: 'Section1',
        anim: {
          name: 'contactAnim',
          delay: 0,
        },
        left: {
          classes: ['bg-color-light-gray']
        },
        right: {
          classes: ['bg-color-red']
        },
      },
      {
        id: 'proj1sect2',
        name: 'IKEA SSFA dashboard',
        category: 'Project1',
        visible: true,
        isAffixed: false,
        component: 'Section1',
        anim: {
          name: 'contactAnim',
          delay: 0,
        },
      },
      {
        id: 'proj1sect3',
        name: 'Challenges and Constraints',
        category: 'Project1',
        visible: true,
        isAffixed: true,
        component: 'Section1',
        left: {
          classes: ['bg-color-light-gray']
        },
        right: {
          classes: ['bg-color-black']
        },
      },
      {
        id: 'proj1sect4',
        name: 'Original Experience',
        category: 'Project1',
        visible: true,
        isAffixed: true,
        component: 'Section1',
        left: {
          classes: ['bg-color-light-gray']
        },
        right: {
          classes: ['bg-color-yellow']
        },
      },
      {
        id: 'proj1sect5',
        name: 'Mapping Out Pain Points',
        category: 'Project1',
        visible: true,
        isAffixed: true,
        component: 'Section1',
        left: {
          classes: ['bg-color-white']
        },
        right: {
          classes: ['bg-color-white']
        },
      },
      {
        id: 'proj1sect6',
        name: 'Ideation and Sketching',
        category: 'Project1',
        visible: true,
        isAffixed: true,
        component: 'Section1',
        left: {
          classes: ['bg-color-light-gray']
        },
        right: {
          classes: ['bg-color-teal']
        },
      },
      {
        id: 'proj1sect7',
        name: 'Lo Fi Prototyping',
        category: 'Project1',
        visible: true,
        isAffixed: true,
        component: 'Section1',
        left: {
          classes: ['bg-color-white']
        },
        right: {
          classes: ['bg-color-light-gray']
        },
      },
      {
        id: 'proj1sect9',
        name: 'Dialog Box Layout',
        category: 'Project1',
        visible: true,
        isAffixed: false,
        component: 'Section1',
        classes: ['bg-color-gray'],
      },
      {
        id: 'proj1sect10',
        name: 'Dialog Box Goals and Design',
        category: 'Project1',
        visible: true,
        isAffixed: false,
        component: 'Section1',
        classes: ['bg-color-black'],
      },
      {
        id: 'proj1sect11',
        name: 'Main Overview',
        category: 'Project1',
        visible: true,
        isAffixed: false,
        component: 'Section1',
        classes: ['bg-color-gray'],
      },
      {
        id: 'proj1sect13',
        name: 'Commerciality Category Tab',
        category: 'Project1',
        visible: true,
        isAffixed: false,
        component: 'Section1',
        classes: ['bg-color-gray'],
      },
      {
        id: 'proj1sect15',
        name: 'Key Dashboard Functions',
        category: 'Project1',
        visible: true,
        isAffixed: false,
        component: 'Section1',
        classes: ['bg-color-black'],
      },
      {
        id: 'proj1sect16',
        name: 'Tabs',
        category: 'Project1',
        visible: true,
        isAffixed: false,
        component: 'Section1',
        classes: ['bg-color-black'],
      },
      {
        id: 'proj1sect18',
        name: 'Displaying the Commerciality Graph',
        category: 'Project1',
        visible: true,
        isAffixed: true,
        component: 'Section1',
        left: {
          classes: ['bg-color-light-gray']
        },
        right: {
          classes: ['bg-color-black']
        },
      },
      {
        id: 'proj1sect19',
        name: 'Secondary Dashboard Functions',
        category: 'Project1',
        visible: true,
        isAffixed: true,
        component: 'Section1',
        left: {
          classes: ['bg-color-light-gray']
        },
        right: {
          classes: ['bg-color-red']
        },
      },
      {
        id: 'proj1sect20',
        name: 'Concluding Thoughts and Shortfalls',
        category: 'Project1',
        visible: true,
        isAffixed: true,
        component: 'Section1',
        left: {
          classes: ['bg-color-white']
        },
        right: {
          classes: ['bg-color-white']
        },
      },
      {
        id: 'proj2sect1',
        name: 'SECOND STAGE APP',
        category: 'Project2',
        visible: true,
        isAffixed: true,
        component: 'Section1',
        left: {
          classes: ['bg-color-white']
        },
        right: {
          classes: ['bg-color-teal']
        },
      },
      {
        id: 'proj2sect2',
        name: 'concept video',
        category: 'Project2',
        visible: true,
        isAffixed: false,
        component: 'Section1',
        classes: ['bg-color-light-gray'],
      },
      {
        id: 'proj2sect3',
        name: 'Task and Project Format',
        category: 'Project2',
        visible: true,
        isAffixed: true,
        component: 'Section1',
        left: {
          classes: ['bg-color-white']
        },
        right: {
          classes: ['bg-color-white']
        },
      },
      {
        id: 'proj2sect4',
        name: 'The theatre and the players',
        category: 'Project2',
        visible: true,
        isAffixed: true,
        component: 'Section1',
        left: {
          classes: ['bg-color-light-gray']
        },
        right: {
          classes: ['bg-color-white']
        },
      },
      {
        id: 'proj2sect5',
        name: 'Understanding the roles',
        category: 'Project2',
        visible: true,
        isAffixed: false,
        component: 'Section1',
        classes: ['bg-color-white'],
      },
      {
        id: 'proj2sect6',
        name: 'The engaging experience',
        category: 'Project2',
        visible: true,
        isAffixed: true,
        component: 'Section1',
        left: {
          classes: ['bg-color-black']
        },
        right: {
          classes: ['bg-color-light-gray']
        },
      },
      {
        id: 'proj2sect10',
        name: 'Understanding the users world',
        category: 'Project2',
        visible: true,
        isAffixed: false,
        component: 'Section1',
        classes: ['bg-color-white'],
      },
      {
        id: 'proj2sect11',
        name: 'Concepts',
        category: 'Project2',
        visible: true,
        isAffixed: false,
        component: 'Section1',
        classes: ['bg-color-light-gray'],
      },
      {
        id: 'proj2sect15',
        name: 'Goals',
        category: 'Project2',
        visible: true,
        isAffixed: true,
        component: 'Section1',
        left: {
          classes: ['bg-color-light-gray']
        },
        right: {
          classes: ['bg-color-red']
        },
      },
      {
        id: 'proj2sect16',
        name: 'Mentor',
        category: 'Project2',
        visible: true,
        isAffixed: true,
        component: 'Section1',
        left: {
          classes: ['bg-color-light-gray']
        },
        right: {
          classes: ['bg-color-white']
        },
      },
      {
        id: 'proj2sect17',
        name: 'Connect',
        category: 'Project2',
        visible: true,
        isAffixed: true,
        component: 'Section1',
        left: {
          classes: ['bg-color-light-gray']
        },
        right: {
          classes: ['bg-color-red']
        },
      },
      {
        id: 'proj2sect18',
        name: 'Inform',
        category: 'Project2',
        visible: true,
        isAffixed: false,
        component: 'Section1',
        classes: ['bg-color-white'],
      },
      {
        id: 'proj2sect20',
        name: 'Concept Video',
        category: 'Project2',
        visible: true,
        isAffixed: false,
        component: 'Section1',
        classes: ['bg-color-light-gray'],
      },
      {
        id: 'proj3sect1',
        name: 'IKEA Video Contest Entry',
        category: 'Project3',
        visible: true,
        isAffixed: true,
        component: 'Section1',
        left: {
          classes: ['bg-color-white']
        },
        right: {
          classes: ['bg-color-teal']
        },
      },
      {
        id: 'proj3sect2',
        name: 'video entry',
        category: 'Project3',
        visible: true,
        isAffixed: false,
        component: 'Section1',
        classes: ['bg-color-light-gray'],
      },
      // {
      //   id: 'proj3sect3',
      //   name: 'Task',
      //   category: 'Project3',
      //   visible: true,
      //   isAffixed: true,
      //   component: 'Section1',
      //   left: {
      //     classes: ['bg-color-white']
      //   },
      //   right: {
      //     classes: ['bg-color-red']
      //   },
      // },
      {
        id: 'proj3sect4',
        name: 'Approach',
        category: 'Project3',
        visible: true,
        isAffixed: true,
        component: 'Section1',
        left: {
          classes: ['bg-color-light-gray']
        },
        right: {
          classes: ['bg-color-light-gray']
        },
      },
      {
        id: 'proj3sect5',
        name: 'Outcome',
        category: 'Project3',
        visible: true,
        isAffixed: true,
        component: 'Section1',
        left: {
          classes: ['bg-color-white']
        },
        right: {
          classes: ['bg-color-white']
        },
      },
      {
        id: 'proj3sect6',
        name: 'Video',
        category: 'Project3',
        visible: true,
        isAffixed: false,
        component: 'Section1',
        classes: ['bg-color-light-gray'],
      },
    ]
  },
  mutations: {
    SHOW_NAV: (state, payload) => {
      state.navVisible = true
    },
		SET_CONTAINER_SIZE: (state, payload) => {
			state.containerSize = payload
    },
  },
  actions: {
    showNav: ({commit}) => {
      commit('SHOW_NAV')
    },
		updateContainerSize: ({commit}, payload) => {
      commit('SET_CONTAINER_SIZE', payload)
    },
  },
  getters: {
    navVisible: (state) => { return state.navVisible },
    containerSize: (state) => { return state.containerSize },
    sections: (state) => { return state.sections },
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js